import { render, staticRenderFns } from "./CheckoutWrapper.vue?vue&type=template&id=6bfeb9c2"
import script from "./CheckoutWrapper.vue?vue&type=script&lang=ts"
export * from "./CheckoutWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports